import Validator from "../../Components/FormComponent/Validator";

const FORM_TYPE = {
    login: 0,
    signup: 1,
};

const FORM_LOGIN = [
    {
        key: "hsg-auth-login-username",
        label: "",
        type: "text",
        placeholder: "Mobile number/Email Address",
        meta: {
            value: "loginFormUserName",
            error: "loginFormErrorUserName"
        }
    },
    {
        key: "hsg-auth-login-password",
        label: "",
        type: "password",
        placeholder: "Enter password",
        meta: {
            value: "loginFormPassword",
            error: "loginFormErrorPassword"
        }
    },
];

const FORM_SIGN_UP = [
    {
        groupClass: "hsg-auth-content-sign-up-form-group col-sm-6 col-xs-12",
        key: "hsg-auth-sign-up-first-name",
        meta: {
            value: "signUpFormFirstName",
            error: "signUpFormErrorFirstName"
        },
        type: "text",
        label: "First Name",
        placeholder: "",
    },
    {
        groupClass: "hsg-auth-content-sign-up-form-group col-sm-6 col-xs-12",
        key: "hsg-auth-sign-up-last-name",
        meta: {
            value: "signUpFormLastName",
            error: "signUpFormErrorLastName"
        },
        type: "text",
        label: "Last Name",
        placeholder: "",
    },
    {
        groupClass: "hsg-auth-content-sign-up-form-group col-xs-12",
        key: "hsg-auth-sign-up-email-address",
        meta: {
            value: "signUpFormEmailAddress",
            error: "signUpFormErrorEmailAddress"
        },
        type: "text",
        label: "Email Address",
        placeholder: "",
    },
    {
        groupClass: "hsg-auth-content-sign-up-form-group col-xs-12",
        key: "hsg-auth-sign-up-phone-number",
        meta: {
            value: "signUpFormPhoneNumber",
            error: "signUpFormErrorPhoneNumber"
        },
        type: "text",
        label: "Mobile Number",
        placeholder: "",
    },
    {
        groupClass: "hsg-auth-content-sign-up-form-group col-xs-12",
        key: "hsg-auth-sign-up-create-password",
        meta: {
            value: "signUpFormCreatePassword",
            error: "signUpFormErrorCreatePassword"
        },
        type: "password",
        label: "Create Password",
        placeholder: "",
    },
];

const TYPE_MODAL = {
    magicLink: "MAGIC_LINK",
    forgotAccount: "forgotAccount",
    otp: "OTP",
    all: null,
};

const STRING_ERROR_EMPTY_FIELD_MESSAGE = (label) => `${label} cannot be blank`
const STRING_ERROR_USERNAME = "Please enter a valid mobile number/email address"

const STRING_LOGIN_FORM_HEAD = "WELCOME BACK!";
const STRING_LOGIN_FORM_FORGOT_PASSWORD = "Forgotten Account?";
const STRING_LOGIN_FORM_SUBMISSION = "Let's Go";
const STRING_LOGIN_FORM_OTHER_OPTIONS = {
    0: "Log in with the",
    1: "Magic Link",
    2: "Or",
    3: "OTP",
};
const STRING_LOGIN_FORM_SIGNUP_SWITCH = {
    0: "Don’t have an account? Create one by",
    1: "Signing up",
};
const STRING_LOGIN_FORM_RESPONSE_INCORRECT_USERNAME =
    "Please enter a valid mobile number/email address or recover your account.";
const STRING_LOGIN_FORM_RESPONSE_INCORRECT_PASSWORD = "Hmm, that's not the right password. Please try again or recover your account.";

const STRING_SIGN_UP_FORM_HEAD = "Create Your HealthSetGo Account";
const STRING_SIGN_UP_FORM_SUB_HEAD = "This is an independent account and does not link back to any institution. If you are part of an institution/school or college. Request your institution for your customized account link.";
const STRING_SIGN_UP_FORM_RESPONSE_EMAIL_TAKEN = "Email already exists in our system";
const STRING_SIGN_UP_FORM_RESPONSE_PHONE_TAKEN = "Phone number already exists in our system";
const STRING_SIGN_UP_FORM_DATA_POLICY = {
    0: "By clicking Let’s Go, you have agreed to the applicable",
    1: "Data Policy"
}
const STRING_SIGN_UP_FORM_SUBMISSION = "Let's Go"
const STRING_SIGN_UP_FORM_LOGIN_SWITCH = "Back to Login"

const STRING_FOOTER_NUMBER = "+91-9555553311"
const STRING_FOOTER_EMAIL = "hello@healthsetgo.com"
const STRING_FOOTER_COPYRIGHT = "Copyright by HealthSetGo"

export default {
    FORM_TYPE,
    FORM_LOGIN,
    FORM_SIGN_UP,

    TYPE_MODAL,

    STRING_ERROR_EMPTY_FIELD_MESSAGE,
    STRING_ERROR_USERNAME,

    STRING_LOGIN_FORM_HEAD,
    STRING_LOGIN_FORM_FORGOT_PASSWORD,
    STRING_LOGIN_FORM_SUBMISSION,
    STRING_LOGIN_FORM_OTHER_OPTIONS,
    STRING_LOGIN_FORM_SIGNUP_SWITCH,
    STRING_LOGIN_FORM_RESPONSE_INCORRECT_USERNAME,
    STRING_LOGIN_FORM_RESPONSE_INCORRECT_PASSWORD,

    STRING_SIGN_UP_FORM_HEAD,
    STRING_SIGN_UP_FORM_SUB_HEAD,
    STRING_SIGN_UP_FORM_RESPONSE_EMAIL_TAKEN,
    STRING_SIGN_UP_FORM_RESPONSE_PHONE_TAKEN,
    STRING_SIGN_UP_FORM_DATA_POLICY,
    STRING_SIGN_UP_FORM_SUBMISSION,
    STRING_SIGN_UP_FORM_LOGIN_SWITCH,

    STRING_FOOTER_NUMBER,
    STRING_FOOTER_EMAIL,
    STRING_FOOTER_COPYRIGHT

};
